export interface UploadImageFileLike {
  name: string;
  type: string;
}

const imageMimeTypeByExtension: Record<string, string> = {
  avif: 'image/avif',
  gif: 'image/gif',
  heic: 'image/heic',
  heif: 'image/heif',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
};

export function getFileExtension(file: Pick<UploadImageFileLike, 'name'>): string {
  const filename = file.name.toLowerCase();
  const lastDotIndex = filename.lastIndexOf('.');
  return lastDotIndex >= 0 ? filename.slice(lastDotIndex + 1) : '';
}

function isRawCameraFormat(file: UploadImageFileLike): boolean {
  const filename = file.name.toLowerCase();
  const mimeType = file.type.toLowerCase();

  return (
    mimeType === 'image/x-adobe-dng'
    || filename.endsWith('.dng')
    || filename.endsWith('.raw')
  );
}

export function inferUploadMimeType(file: UploadImageFileLike): string {
  const extension = getFileExtension(file);
  const inferredMimeType = imageMimeTypeByExtension[extension] ?? '';

  if (file.type && !file.type.startsWith('image/')) {
    throw new Error('이미지 파일만 등록할 수 있습니다.');
  }

  const mimeType = file.type || inferredMimeType;

  if (!mimeType) {
    throw new Error('이미지 파일만 등록할 수 있습니다.');
  }

  if (isRawCameraFormat(file)) {
    throw new Error('이 사진 형식은 휴대폰 브라우저에서 바로 처리하기 어렵습니다. 일반 사진 파일을 선택해 주세요.');
  }

  return mimeType;
}
